__turbopack_context__.v({
  "actions": "Card-module-scss-module__KdIXpW__actions",
  "arrow": "Card-module-scss-module__KdIXpW__arrow",
  "button": "Card-module-scss-module__KdIXpW__button",
  "card": "Card-module-scss-module__KdIXpW__card",
  "content": "Card-module-scss-module__KdIXpW__content",
  "icon": "Card-module-scss-module__KdIXpW__icon",
  "image": "Card-module-scss-module__KdIXpW__image",
  "link": "Card-module-scss-module__KdIXpW__link",
  "text": "Card-module-scss-module__KdIXpW__text",
  "title": "Card-module-scss-module__KdIXpW__title",
});
